import type { IEnrichableEntity, KeyedMarketDataSnapshot, Security } from '@talos/kyoko';
import { compact, values } from 'lodash-es';

export class PriceBlotterEntity implements IEnrichableEntity<PriceBlotterEntity, KeyedMarketDataSnapshot> {
  readonly security: Security;
  marketData: { [key: string]: KeyedMarketDataSnapshot } = {};

  addEnrichments(enrichments: KeyedMarketDataSnapshot[]) {
    for (const enrichment of enrichments) {
      this.marketData[enrichment.requestKey] = enrichment;
    }
  }

  removeEnrichments(ids: string[]): void {
    for (const id of ids) {
      delete this.marketData[id];
    }
  }

  clearEnrichments(): void {
    this.marketData = {};
  }

  getEnrichments(): KeyedMarketDataSnapshot[] {
    return values(this.marketData);
  }

  getEnrichmentRequirements(): string[] {
    return compact([
      this.security.Symbol,
      this.security.MultilegDetails?.Legs?.at(0)?.Symbol,
      this.security.MultilegDetails?.Legs?.at(1)?.Symbol,
    ]);
  }

  hasEnrichment(id: string) {
    return id in this.marketData;
  }

  clone() {
    const clone = new PriceBlotterEntity(this.security);
    clone.addEnrichments(this.getEnrichments());
    return clone;
  }

  get rowID() {
    return this.security.Symbol;
  }

  constructor(security: Security) {
    this.security = security;
  }
}
